export enum VariableName {
  AppName = 'app-name',
  AppDescription = 'app-description',
  AppVersionLabel = 'app-version-label',
  AppTaskOperationName = 'app-task-operation-name',
  AppTaskPackageSize = 'app-task-package-size',
  AppTaskDownloadedSize = 'app-task-downloaded-size',
  AppTaskDownloadSpeed = 'app-task-download-speed',
  AppTaskPercentage = 'app-task-percentage',
  AppInstallPath = 'app-install-path',
  AppInstallPackageSize = 'app-install-package-size',
  AppUpdatePackageSize = 'app-update-package-size',
}
